import sortByStartDates from "../sort-by-start-dates";

export default function getCurrentPeriod(items) {
  // Ensure chronologically ascending sort order.
  sortByStartDates(items);

  const now = new Date();
  return items.reduce((acc, cur) => {
    // First one found is the one we want.
    if (acc) {
      return acc;
    }

    // Note, the following applies for the time part if these `DateTime`s are not `null` or `undefined`:
    // - `startDate` is always set to 00:00:00.000 (= first day)
    // - `endDate` is always set to 23:59:59.999 (= last day)
    // However:
    // - `frontendDisplayStartDate` is always set to 00:00:00.000 (= first visible day)
    // - `frontendDisplayEndDate` is *also* always set to 00:00:00.000! (= next day, or first invisible day)
    // => The season field `frontend_display_end_date` is used as the table's TYPO3 `endtime`.
    //    Its label is, for clarification, changed to "Invisible starting from (at midnight)".
    //    We do not want editors to have to select 23:59 in a date picker - that would be error prone.

    // Match the one (if any) which the current date falls into.
    if (new Date(cur.startDate) <= now && new Date(cur.endDate) >= now) {
      return cur;
    }

    // Carry either null or the matched item
    // if conditions do not apply.
    // -> Replace acc (null) with cur when the condition matches
    //    and do not change acc after the first assignment.
    return acc;
  }, null);
}
